import { render } from "./WCSaveAllItemsForLaterModal.vue?vue&type=template&id=38a8be1a&scoped=true"
import script from "./WCSaveAllItemsForLaterModal.vue?vue&type=script&lang=js"
export * from "./WCSaveAllItemsForLaterModal.vue?vue&type=script&lang=js"

import "./WCSaveAllItemsForLaterModal.vue?vue&type=style&index=0&id=38a8be1a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a8be1a"]])

export default __exports__